import { PickSessionSchema } from "@redotech/redo-model/wms/schema/pick-session";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const scanAssignedLicensePlateForPickSession = {
  name: "scanAssignedLicensePlateForPickSession" as const,
  input: z.object({
    pickSessionId: zExt.objectId(),
    fulfillmentGroupId: zExt.objectId(),
    scannedValue: z.string(),
  }),
  output: z.object({
    success: z.boolean(),
    updatedPickSession: PickSessionSchema.nullish(),
  }),
};
